import { useEffect, useRef, useState } from "react";

/** An element's border-box height, following resizes. `null` until measured
 *  and wherever ResizeObserver is missing. */
export function useElementHeight<T extends HTMLElement>() {
    const ref = useRef<T | null>(null);
    const [height, setHeight] = useState<number | null>(null);
    useEffect(() => {
        const element = ref.current;
        if (!element || typeof ResizeObserver === "undefined") return;
        const observer = new ResizeObserver((entries) => {
            const next = entries[0]?.borderBoxSize?.[0]?.blockSize;
            if (next !== undefined) setHeight((previous) => (previous === next ? previous : next));
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, []);
    return { ref, height };
}
